import { RouteProps } from 'react-router';
import ResetDevices from '../auth/ResetDevices';
import ResetPin from '../dashboard/ResetPin';
import ResetDeviceOtp from './ResetDeviceOtp';

export const StackConfig: RouteProps[] = [
    {
        path: '/reset-pin',
        component: ResetPin,
    },
    {
        path: '/reset-devices',
        component: ResetDevices,
    },
    {
        path: '/reset-device-otp',
        component: ResetDeviceOtp,
    },
];
